module.exports = __webpack_public_path__ + "static/img/2.42bc56b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/2.png
// module id = lV3L
// module chunks = 0